// Theme variables injected by gulp
var THEME_NAME;

THEME_NAME = 'bogen';

angular.module('app.controllers').controller('ProgramsCtrl', ['$scope', '$rootScope', 'APIPrograms', 'Table', 'APIProgramsTable', '$cookies'].append(function(self, root, APIPrograms, Table, APIProgramsTable, $cookies) {
  var cookiesName, ref, searchParams, tableName;
  tableName = 'c.pro.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'page');
  cookiesName = 't.' + tableName;
  
  // Search dropdown functionality

  self.term = "";
  searchParams = {
    search: self.term,
    page: 1,
    limit: 10
  };
  self.sugg = Table({
    name: tableName + ".sugg",
    type: "partial",
    resource: APIProgramsTable,
    cookies: true,
    params: searchParams
  });
  self.onSearchTermChange = function() {
    return self.sugg.params.search = self.term;
  };
  self.initSearchDropdown = function() {
    var searchDropdown, searchInput;
    searchInput = document.getElementById('searchInput');
    searchDropdown = document.getElementById('searchDropdown');
    if (!(searchInput && searchDropdown)) {
      return;
    }
    // Show dropdown when input is focused (including tab navigation)
    searchInput.addEventListener('focus', function() {
      // Don't show dropdown if input has ng-invalid class
      if (!searchInput.classList.contains('ng-invalid')) {
        return searchDropdown.classList.add('show');
      }
    });
    // Hide dropdown when input loses focus (including tab navigation)
    searchInput.addEventListener('blur', function() {
      // Small delay to allow clicking on dropdown items
      return setTimeout(function() {
        if (!searchDropdown.contains(document.activeElement)) {
          return searchDropdown.classList.remove('show');
        }
      }, 100);
    });
    // Prevent dropdown from closing when clicking inside the input
    searchInput.addEventListener('click', function(e) {
      e.stopPropagation();
      // Don't show dropdown if input has ng-invalid class
      if (!searchInput.classList.contains('ng-invalid')) {
        return searchDropdown.classList.add('show');
      }
    });
    // Prevent dropdown from closing when clicking inside the dropdown menu
    searchDropdown.addEventListener('click', function(e) {
      return e.stopPropagation();
    });
    // Close dropdown when clicking outside
    document.addEventListener('click', function(e) {
      if (!(searchInput.contains(e.target) || searchDropdown.contains(e.target))) {
        return searchDropdown.classList.remove('show');
      }
    });
    // Close dropdown when pressing Escape key
    return searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        searchDropdown.classList.remove('show');
        return searchInput.blur();
      }
    });
  };
  self.closeDropdown = function() {
    self.term = "";
    self.onSearchTermChange();
    searchDropdown.classList.remove('show');
    return searchInput.blur();
  };
  // Watch term changes and control dropdown visibility based on ng-invalid class
  self.$watch('term', function(newValue, oldValue) {
    var searchDropdown, searchInput;
    searchInput = document.getElementById('searchInput');
    searchDropdown = document.getElementById('searchDropdown');
    if (!(searchInput && searchDropdown)) {
      return;
    }
    if (searchInput.classList.contains('ng-invalid')) {
      return searchDropdown.classList.remove('show');
    } else if (newValue && newValue.trim() && searchInput === document.activeElement) {
      return searchDropdown.classList.add('show');
    }
  });
  // Initialize dropdown when controller is ready
  self.initSearchDropdown();
  self.speaker = null;
  self.speakerModalEl = document.getElementById('speakerModal');
  if (self.speakerModalEl) {
    self.speakerModal = bootstrap.Modal.getOrCreateInstance(self.speakerModalEl);
    self.speakerModalEl.addEventListener('show.bs.modal', function(event) {
      return self.$applyAsync();
    });
    self.speakerModalEl.addEventListener('hidden.bs.modal', function(event) {
      self.speaker = null;
      return self.$applyAsync();
    });
  }
  return self.openSpeakerModal = function(speaker) {
    var ref1;
    self.speaker = speaker;
    return (ref1 = self.speakerModal) != null ? ref1.show() : void 0;
  };
}));
